import React from "react";
import {Navbar} from "react-bootstrap";
import logo from "../images/HES_tight.png";

function ServiceHeader({location = "Demo"}) {
    return (
        <Navbar id="header" >
            <Navbar.Brand>
                <img
                    id="logo"
                alt="logo"
                src={logo}
                    // src="/module/hesStationHealth/res/images/HES_tight.png"
                height="35px"
                max-height="100px"
                className="d-inline-block align-top img-responsive"
            />
            </Navbar.Brand>


            <div  className="h1  fs-2 fw-bold m-auto">{location + " - Meter Health Dashboard"}</div>

        </Navbar>

    );
}

export default ServiceHeader;
